import { GaEventService } from '@analytics/services/ga.event.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Comparison,
  CurrentItem,
  Offers,
  ReplacementOffer,
} from '@dgx-pr-spa/shared/util';
import { UrlService } from '@shared/services/url.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { Observable, combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-model-comparison-container',
  templateUrl: './model-comparison.container.html',
})
export class ModelComparisonContainerComponent implements OnInit {
  currentItem$: Observable<CurrentItem>;
  comparisons$: Observable<ReplacementOffer[]>;
  data$: Observable<Comparison[]>;
  offers$: Observable<Offers>;
  previousUrl$: Observable<string>;

  previousUrl: string = null;

  constructor(
    private viewOffersService: ViewOffersService,
    private gaEventService: GaEventService,
    private router: Router,
    private urlSerivce: UrlService
  ) {
    this.currentItem$ = this.viewOffersService.currentItem$;
    this.comparisons$ = this.viewOffersService.comparisons$;
    this.offers$ = this.viewOffersService.offers$;
    this.previousUrl$ = this.urlSerivce.previousUrl$;
  }

  ngOnInit(): void {
    this.urlSerivce.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl;
    });
    this.data$ = combineLatest([this.currentItem$, this.comparisons$]).pipe(
      map(([currentItem, comparisons]) => {
        if (comparisons.length === 0) {
          if (this.previousUrl?.includes('product-details')) {
            this.router.navigate(['/product-details'], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.router.navigate(['/offers'], {
              queryParamsHandling: 'preserve',
            });
          }
        }
        return [currentItem as Comparison, ...(comparisons as Comparison[])];
      })
    );
  }

  /**
   * Offer card compare cta checkbox clicked
   */
  onComparisonRemovedClick(comparison: ReplacementOffer) {
    this.viewOffersService.setComparisons(comparison);
    this.gaEventService.OffersComparisonClick(comparison);
  }

  /**
   * Comparison is selected within the compare basket
   */
  onComparisonSelectedClick(offer: ReplacementOffer) {
    this.viewOffersService.selectOffer(offer);
  }
}
